module.exports = __webpack_public_path__ + "static/media/pink-box-hover.2a14f4a3.png";